import { CommunicationApiResponseSuccess } from '../interface';
import { Observable } from 'rxjs';

export abstract class CommunicationLikeService {
  abstract switchLike(isLiked: boolean, contentId: number): Observable<CommunicationApiResponseSuccess>;
  abstract sendReport(contentId: number, comment: string): Observable<CommunicationApiResponseSuccess>;
}
